import { Routes } from '@root-gipro/router'
import { PurchasesTypeEnum } from '@root-gipro/modules/purchases/models/enums/purchases-type.enum'

export const getPurchaseDetailRoute = (type: string, id: number | string) =>
	Routes.PURCHASES_DETAIL.replace(/:id/g, id.toString()).replace(/:type/g, type)
